import Swiper from 'swiper';

class Slide {


    
    constructor(container) {
        this.swiperOptions = {

            slidesPerView: 4,
            spaceBetween: 50,
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                }
            },
            speed: 500,
            autoplay: {
                delay: 4000
            }
        };
        this.container = container;
        new Swiper(this.container, this.swiperOptions);

    }

}

class DisplayContent {
    constructor(){
        let selettori = document.querySelectorAll('.selettore');
        selettori.forEach((el)=> {



            el.addEventListener('mousemove', ()=> {
                let selettore = el.getAttribute('data-selettore');
                let color = el.getAttribute('data-color');
                document.querySelectorAll('.selettore').forEach(el => el.classList.remove('selettore-attivo'))
                el.classList.add('selettore-attivo');

                selettori.forEach((el)=> {
                  el.style.background = "none";
                  el.querySelector('span').style.opacity = 0;
                });
                el.style.background = color;
              //  el.style.background = "#D9E021"
                el.querySelector('span').style.opacity = 1;


                let content = document.querySelectorAll('.content-info');
                content.forEach((el) => {
                    el.style.display = "none";
                    el.style.background = "none";
                });

                let contentSelect = document.querySelector(`.${selettore}`);
                contentSelect.style.display = 'block';
                contentSelect.style.background = color;
              //  contentSelect.style.background = "#D9E021";
                if(window.innerWidth > 767) {
                    document.querySelector('.sec5 .col-md-8').style.background = color;
                }

            });



        });
    }
}









document.addEventListener('DOMContentLoaded', () => {
   const slideClient = new Slide('.swiper-client');
   const displayContent = new DisplayContent();
});


// WEBPACK FOOTER //
// ./main.js